import formatePrice from '../utils/formatePrice'
import { getString } from '../utils/constants'

const renderItem = offer => {
  let item = ''
  item += `<li
    class="item"
    data-to-iata="${offer.journeys[0]['to-iata']}"
    data-from-iata="${offer.journeys[0]['from-iata']}"
    style="background-image: url(\'https://www.letenky.cz/opencms/export/sites/letenky.cz/sys/images/offers/${offer.journeys[0]['to-iata']}-big.jpg\')"
    >`
    item += `<div class="info">`
      item += `<span class="name">${offer.journeys[0]['to-name']}</span>`
      item += `<span class="price">${getString('FROM')}&nbsp;${formatePrice(offer.total)}&nbsp;${getString('CURRENCY')}</span>`
    item += '</div>'
  item += '</li>'

  return item
}

export default renderItem



// WEBPACK FOOTER //
// ./app/offers/item.js